import React from 'react';
import { STATES } from '../utils/use_game_state';
import Backdrop from './Backdrop';
import Spinner from './Spinner';
import Confetti from './Confetti';
import RelatedGames from './RelatedGames';
import BackButton from './BackButton';

const Game = ({ gameState, children, relatedGames, smallRelated, disableBackdropBeforeDone, assetPath, isApp }) => <>
  {gameState >= STATES.DONE && <Confetti />}
  <div className={`relative overflow-x-hidden w-screen ${isApp ? 'h-screen' : 'game-screen'}`}>
    { !disableBackdropBeforeDone
      ? <Backdrop gameState={gameState} assetPath={assetPath} />
      : gameState >= STATES.DONE && <Backdrop gameState={gameState} assetPath={assetPath} />
    }
    <Spinner gameState={gameState} />
    {isApp || <BackButton />}
    <div className="overflow-y-auto h-full">
      {gameState >= STATES.PLAY && children}
      {gameState >= STATES.RELATED && <RelatedGames games={relatedGames} small={smallRelated}/>}
    </div>
  </div>
</>;

export default Game;
